export default __webpack_public_path__ + "static/media/reaper-lastwords.9e365a93.mp3";